import { Segmented } from './ui';
import { Icon } from './Icon';
import { useTheme, type ThemeChoice } from './theme';
import './styles/theme-toggle.css';

const OPTIONS: { value: ThemeChoice; label: string }[] = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

export function ThemeToggle({ className }: { className?: string }) {
  const { choice, setChoice } = useTheme();

  return (
    <div className={className ? `cev-theme-toggle ${className}` : 'cev-theme-toggle'}>
      <Segmented aria-label="Appearance" options={OPTIONS} value={choice} onChange={setChoice} />
    </div>
  );
}

const THEME_CYCLE_ICON: Record<ThemeChoice, 'monitor' | 'sun' | 'moon'> = {
  system: 'monitor',
  light: 'sun',
  dark: 'moon',
};

export function ThemeCycleButton({ className }: { className?: string }) {
  const { choice, resolved, cycle } = useTheme();
  const icon = THEME_CYCLE_ICON[choice];
  const label = `Appearance: ${choice}. Showing ${resolved}. Change theme`;

  return (
    <button
      type="button"
      className={className ? `cev-theme-cycle ${className}` : 'cev-theme-cycle'}
      aria-label={label}
      title={label}
      onClick={cycle}
    >
      <Icon name={icon} size={20} />
    </button>
  );
}
